module.exports = __webpack_public_path__ + "img/ipad-jp-13.e051bc7.jpg";